import { FaCreditCard, FaDiscord, FaDollarSign, FaShoppingCart, FaStore, FaTags } from "react-icons/fa";
import styles from "./ImageBanner.module.css";

function ImageBanner() {
    return (
        <div className={styles.radialContainer}>
      <div className={`${styles.icon} ${styles.central}`}>
        <FaDiscord className={styles.discordIcon} size={170} />
      </div>

      <div className={`${styles.icon} ${styles.icon1}`}  style={{ top: '10%', left: '50%' }}>
        <FaShoppingCart size={20} />
      </div>
      <div className={`${styles.icon} ${styles.icon2}`} style={{ top: '25%', left: '80%' }}>
        <FaDollarSign size={20} />
      </div>
      <div className={`${styles.icon} ${styles.icon3}`} style={{ top: '70%', left: '85%' }}>
        <FaCreditCard size={20} />
      </div>
      <div className={`${styles.icon} ${styles.icon4}`} style={{ top: '80%', left: '20%' }}>
        <FaTags size={20} />
      </div>
      <div className={`${styles.icon} ${styles.icon5}`} style={{ top: '30%', left: '10%' }}>
        <FaStore size={20} />
      </div>
    </div>
    )
}

export default ImageBanner;